import React from "react";
import CommonModal from "../../../components/Common/CommonModal";
import PropTypes from "prop-types";
import Format from "../../../helpers/Format";

function ContatoCertificadoModal({ modalHook, valuesHook }) {
  const { contatoCertificadoModal, setContatoCertificadoModal } = modalHook;
  const { values } = valuesHook;

  return (
    <CommonModal
      title={values?.razao_social}
      is_open_modal={contatoCertificadoModal}
      set_is_open_modal={setContatoCertificadoModal}
      size="md"
      buttons={<></>}
    >
      <div className="row">
        <div className="col-md-12">
          {values?.socio_administrador && (
            <p>
              <strong>Sócio administrador:</strong>{" "}
              {values?.socio_administrador}
            </p>
          )}
          {values?.celular && (
            <>
              <p>
                <strong>Celular:</strong>{" "}
                {Format.formataCelular(values?.celular)}
              </p>
              {values?.contato_celular && (
                <p>
                  <strong>Nome do contato:</strong> {values?.contato_celular}
                </p>
              )}
            </>
          )}
          {values?.email && (
            <p>
              <strong>E-mail:</strong> {values?.email}
            </p>
          )}
        </div>
      </div>
    </CommonModal>
  );
}

ContatoCertificadoModal.propTypes = {
  modalHook: PropTypes.shape({
    contatoCertificadoModal: PropTypes.bool.isRequired,
    setContatoCertificadoModal: PropTypes.func.isRequired,
  }).isRequired,
  valuesHook: PropTypes.shape({
    values: PropTypes.object.isRequired,
    setValues: PropTypes.func.isRequired,
  }).isRequired,
};

export default ContatoCertificadoModal;
